module.exports = __webpack_public_path__ + "static/media/hamburger.be70b0cc.svg";